import { ComponentPropsWithoutRef, FC } from "react";
import Typography from "../Typography";
import MediaBlock, { MediaBlockData } from "./MediaBlock";

export type BenefitBlockData = {
  title: string;
  description: string;
  media: MediaBlockData;
  cta: string;
};

type BenefitBlockProps = {
  data: BenefitBlockData;
} & ComponentPropsWithoutRef<"section">;

const BenefitBlock: FC<BenefitBlockProps> = ({ data, ...rest }) => {
  return (
    <section
      {...rest}
      className={`${rest.className} flex flex-col md:flex-row-reverse md:odd:flex-row mx-auto md:gap-16 gap-8 my-32 md:my-64 px-3 items-center`}
    >
      <div className="flex-1">
        <div className="flex flex-col gap-8 max-w-xl">
          <Typography variant="h2" component="h2">
            {data.title}
          </Typography>
          <Typography
            variant="body1"
            className="text-slate-500 leading-relaxed"
          >
            {data.description}
          </Typography>
        </div>
      </div>
      <div className="flex-1 rounded-2xl">
        {data.media.src.includes("demo") ? (
          <MediaBlock data={data.media} />
        ) : (
          <div className="bg-slate-150 pt-10 px-10 rounded-2xl">
            <MediaBlock
              data={data.media}
              className="rounded-b-none rounded-t-lg mx-auto max-h-[480px]"
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default BenefitBlock;
